import React, { useState } from 'react'
import { Checkbox } from 'components/common/Checkbox/Checkbox'
import { FlexColumn, FlexRow } from 'components/common/Containers'
import Input from 'components/common/Input/Input'
import { Button } from 'components/common/Buttons/Button'
import { notificationController } from 'notificationController/notificationController'
import { Collapse } from 'components/common/Collapse'
import { extensionRegex } from 'constants/regex'
import styles from '../index.module.scss'
import internalStyles from './ExtensionFilter.module.scss'

const initialExtensions = [
  {
    label: '.com',
    value: 'com',
  },
  {
    label: '.net',
    value: 'net',
  },
  {
    label: '.ag',
    value: 'ag',
  },
  {
    label: '.gg',
    value: 'gg',
  },
  {
    label: '.xyz',
    value: 'xyz',
  },
  {
    label: '.to',
    value: 'to',
  },
  {
    label: '.co',
    value: 'co',
  },
  {
    label: '.io',
    value: 'io',
  },
]

const defaultExtensions = [
  'info',
  'fr',
  'sh',
  'fi',
  'nl',
  'me',
  'pl',
  'app',
  'pro',
]

interface Props {
  values: string[]
  onChange: (extensions: string[]) => void
}

const ExtensionFilter: React.FC<Props> = ({ onChange, values }) => {
  const [inputValue, setInputValue] = useState('')
  const [extensions, setExtensions] = useState(initialExtensions)

  const handleAdd = (inputValue) => {
    if (inputValue) {
      const formattedInputValue = inputValue.toLowerCase().replaceAll('.', '')

      if (!new RegExp(extensionRegex).test(inputValue)) {
        notificationController.show({
          description: 'Invalid domain extension',
          status: 'error',
        })
      } else if (!values.includes(inputValue)) {
        setExtensions([
          ...extensions,
          {
            label: `.${formattedInputValue}`,
            value: formattedInputValue,
          },
        ])

        setInputValue('')
      } else {
        notificationController.show({
          description: `Extension «${inputValue}» already exists in the list`,
          status: 'error',
        })
      }
    }
  }

  return (
    <Collapse
      gap="20px"
      header={<h6 className={styles.filterTitle}>Extension</h6>}
      hasArrow
      defaultOpen
    >
      <FlexColumn gap="23px" align="normal">
        <FlexColumn gap="8px" align="normal">
          {extensions.map((extension) => (
            <Checkbox
              key={extension.value}
              value={extension.value}
              checked={values.includes(extension.value)}
              isFormik={false}
              onChange={(event) => {
                onChange(
                  event.target.checked
                    ? [...values, extension.value]
                    : values.filter((ext) => ext !== extension.value)
                )
              }}
            >
              {extension.label}
            </Checkbox>
          ))}
        </FlexColumn>

        <FlexRow justify="space-between" align="center">
          <div className={internalStyles.inputWrapper}>
            <Input
              value={inputValue}
              defaultValues={defaultExtensions}
              onDefaultValueClick={(value) => {
                setInputValue(value)
                handleAdd(value)
              }}
              placeholder="Add extension"
              isFormik={false}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleAdd(inputValue)
                }
              }}
            />
          </div>

          <Button
            className={internalStyles.button}
            onClick={() => {
              handleAdd(inputValue)
            }}
          >
            +
          </Button>
        </FlexRow>
      </FlexColumn>
    </Collapse>
  )
}

export default ExtensionFilter
